import { Page } from '@/components/layout/page/page.tsx'

export const FollowUpMessagesPageSkeleton = () => {
  return (
    <Page>
      <div className="flex flex-col gap-[40px]">
        <div className="bg-skeleton animate-pulse w-full h-[100px] rounded-lg mb-2" />
        <div className="bg-skeleton animate-pulse w-full h-[100px] rounded-lg mb-2" />
        <div className="bg-skeleton animate-pulse w-full h-[400px] rounded-lg mb-2" />
      </div>
    </Page>
  )
}
